module.exports = __webpack_public_path__ + "static/img/game2.d44c4b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/game2.png
// module id = wTKd
// module chunks = 1